import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../auth/useAuth.ts';
import { Landing } from '../pages/Landing.tsx';
import { LoadingNotice } from './LoadingNotice.tsx';

/** Guests see the title sheet; signed-in captains go straight to their harbour. */
export function Home() {
  const { status } = useAuth();
  if (status === 'loading' || status === 'signing-out') return <LoadingNotice />;
  return status === 'authenticated' ? <Navigate to="/harbour" replace /> : <Landing />;
}

/** Sends guests to Keycloak, remembering where they were heading. */
export function RequireAuth() {
  const { status, signIn } = useAuth();
  const location = useLocation();
  const returnTo = `${location.pathname}${location.search}`;
  useEffect(() => {
    if (status === 'anonymous') void signIn(returnTo);
  }, [status, signIn, returnTo]);
  return status === 'authenticated' ? <Outlet /> : <LoadingNotice />;
}
